import { merge, Heading, Description } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import React from 'react'

interface SettingsRowProps {
  children: React.ReactNode
  className?: string
  description: React.ReactNode
  heading: React.ReactNode
}

export const SettingsRow = observer(function SettingsRow({
  children,
  className,
  description,
  heading
}: SettingsRowProps): React.ReactElement {
  return (
    <div className={merge('p-4 md:p-6 border-b last:border-b-0 border-shade-3', className)}>
      <div className='flex flex-col justify-between gap-2 xs:flex-row xs:gap-6'>
        <div className='flex flex-col gap-2'>
          <Heading>{heading}</Heading>
          <Description>{description}</Description>
        </div>

        <div className='flex max-w-xs items-center justify-end'>{children}</div>
      </div>
    </div>
  )
})
